module.exports = __webpack_public_path__ + "media/images/vp/parallax.02.3-c0fd6bcb1b98dac6dc02778012d29dfe.png";